import client from '@/lib/axios-client'
import type { NotificationListOutput } from '@/types/notification'

const NOTIFICATIONS_URL = '/notifications'

export async function getNotifications(): Promise<NotificationListOutput> {
	const response = await client.get(NOTIFICATIONS_URL)
	const payload = response.data.data

	if (Array.isArray(payload)) {
		return { items: payload }
	}

	if (payload && Array.isArray(payload.items)) {
		return { items: payload.items }
	}

	return { items: [] }
}

export async function markNotificationAsRead(id: string): Promise<void> {
	await client.patch(`${NOTIFICATIONS_URL}/${id}/read`)
}

export async function resolveNotification(id: string): Promise<void> {
	await client.patch(`${NOTIFICATIONS_URL}/${id}/resolve`)
}

export async function registerDeviceToken(token: string): Promise<void> {
	await client.post(`${NOTIFICATIONS_URL}/devices`, { token })
}

export async function unregisterDeviceToken(token: string): Promise<void> {
	await client.delete(`${NOTIFICATIONS_URL}/devices`, { data: { token } })
}
